/* eslint-disable */ ;
// console.log = function () {}
// console.warn = function () {}

var slick = require('slick-carousel');

$('.card-header .btn-link').on('click', function () {
	$(this).toggleClass('opened').find('i').toggleClass(' fa-chevron-down  fa-chevron-right');
});

if ($('.naccordion').length > 0) {


	$('.naccordion').on('hide.bs.collapse', function (event) {
		// Get the active card element
		if ($(event.target).closest('.card').length > 0) {
			$(event.target).closest('.naccordion').find('.card').removeClass('openedCard');
			$(event.target).closest('.naccordion').find('.btn-link').removeClass('opened');

		}
	});


	$('.naccordion').on('shown.bs.collapse', function (event) {
		// Get the active card element
		if ($(event.target).closest('.card').length > 0) {


			$(event.target).closest('.naccordion').find('.card').removeClass('openedCard');



			var activeCard = $(event.target).closest('.card');

			// Add a class to the active card
			activeCard.addClass('openedCard');
			$(event.target).closest('.card').find('.btn-link').addClass('opened');
		}
	});

}



function checkbox() {


	$('.check-wrap input[type="radio"] ,.check-wrap input[type="checkbox"]').click(function () {

		console.log('checked', $(this).is(':checked'))
		var inputValue = $(this).attr("target");
		var targetBox = $("." + inputValue);

		if ($(this).is(':checked')) {

			$(this).closest(".check-wrap").find(".more-add").not(targetBox).hide();
			$(targetBox).show().removeClass('d-none');
		} else {
			$(this).closest(".check-wrap").find(".more-add").not(targetBox).show();
			$(targetBox).hide().addClass('d-none');
		}
	});



	// var $ = require('jquery');
	// $('[name="other-language"]').click(function(e) {
	//     $('[name="otherLanguage"]').toggleClass('d-none');
	// });

}

checkbox()

dropdown()

function dropdown() {
	var SelectFx = require('periodicjs.component.selectfx');
	[].slice.call(document.querySelectorAll('select.cs-select')).forEach(function (el) {
		new SelectFx(el);
	});
	// returning error validation
	$('div.cs-select.cs-skin-slide').append('<div class="messages"></div>');
}

// $('div.cs-select.cs-skin-slide').prepend('<div class="message"></div>');



function slickaboutslider() {
	if ($('body').hasClass('Ar')) {
		if ($('.about-slider').length > 0) {

			$('.about-slider').slick({

				arrows: false,
				autoplay: false,
				dots: true,
				adaptiveHeight: true,
				rtl: true
			});
		}

		if ($('.service-work-slider').length > 0) {


			$('.service-work-slider').slick({
				slidesToShow: 3,
				infinite: false,
				draggable: false,
				arrows: false,
				autoplay: false,
				dots: true,
				touchMove: false,

				rtl: true
			});
			$('.service-work-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
				$('.service-work-slider .slick-slide.slick-main-active').removeClass('slick-main-active');
				if (nextSlide > currentSlide) {
					$('.slide.lg-slide').addClass('prev').closest('.slick-slide').addClass('nextSlick').next('.slick-slide').find('.slide').addClass('lg-slide');

				} else {
					$('.slide.lg-slide').addClass('prev').closest('.slick-slide').addClass('prevSlick').prev('.slick-slide').find('.slide').addClass('lg-slide');
				}

				$('.slide.lg-slide.prev').removeClass('prev lg-slide')

			});
		}

	} else {
		if ($('.about-slider').length > 0) {

			$('.about-slider').slick({
				arrows: false,
				autoplay: false,
				dots: true,
				adaptiveHeight: true


			});
		}
		if ($('.service-work-slider').length > 0) {


			$('.service-work-slider').slick({
				slidesToShow: 3,
				infinite: false,
				draggable: false,
				arrows: false,
				autoplay: false,
				dots: true,
				touchMove: false,

			});
			let theactivebefore;
			$('.service-work-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {

				theactivebefore = currentSlide;
			});

			$('.service-work-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
				$('.service-work-slider .slick-slide.slick-main-active').removeClass('slick-main-active');
				if (nextSlide > currentSlide) {
					$('.slide.lg-slide').addClass('prev').closest('.slick-slide').addClass('nextSlick').next('.slick-slide').find('.slide').addClass('lg-slide');

				} else {
					$('.slide.lg-slide').addClass('prev').closest('.slick-slide').addClass('prevSlick').prev('.slick-slide').find('.slide').addClass('lg-slide');
				}

				$('.slide.lg-slide.prev').removeClass('prev lg-slide')

			});
		}
	}
}

slickaboutslider();


//
function slicklayerslider() {
	var slider,
		$slides;
	var slick = require('slick-carousel');
	if ($('body').hasClass('Ar')) {
		$('.slideit').slick({
			autoplay: true,
			adaptiveHeight: true,
			autoplaySpeed: 2500,
			arrows: false,
			fade: true,
			infinite: true,
			rtl: true
		});
	} else {
		$('.slideit').slick({
			autoplay: true,
			adaptiveHeight: true,
			autoplaySpeed: 2500,
			arrows: false,
			fade: true,
			infinite: true,
		});
	}
}

slicklayerslider();
//






/// for end-of-year-newsletter plan 



$('.scroll_on_click').click(function (e) {
	e.preventDefault();
	// // console.log('startup');
	console.log('sss', $(this).attr('data'));
	let data_passed = $(this).attr('data');
	// $('input.form-check-input').prop('checked', false);
	$('#' + data_passed).prop('checked', true);
	$([document.documentElement, document.body]).animate({
		scrollTop: $(".interested-in").offset().top
	}, 500);


});








$('.start-btn').click(function (e) {
	e.preventDefault();
	// // console.log('startup')
	$([document.documentElement, document.body]).animate({
		scrollTop: $(".pricing--sonam").offset().top - 100
	}, 500);
});






// $(document).ready(function () {
// 	var $ = require('jquery');
// });
$(document).ready(function () {
	// FOR MP4 HOME VIDEO TO WORK ON SAFARI
	if (('.thevideo .video').length > 0) {
		$('.thevideo .playvideo').click(function (e) {

			$('.thevideo video').trigger('play');


		})
		if ($('.thevideo .playvideo').length > 0) {
			$('.thevideo .playvideo').click();
		}
	}
});
$(window).resize(function () {
	if ($('.home-dialog').length) {
		replacepopupimg();
		$(window).resize(function () {
			replacepopupimg();
		});
	}
});

function replacepopupimg() {
	var $ = require('jquery');
	if ($('.home-dialog').length) {
		if ($(window).width() < 960) {
			$('.popupimg').attr('src', popupmobileimage);
			// // console.log(popupmobileimage)
		} else {
			$('.popupimg').attr('src', popupimage);
			// // console.log(popupimage)
		}
	}
}

replacepopupimg()

// function checkbrowser() {
//     var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
//     if (!isChrome) {
//         $('#iframeAudio').remove()
//     } else {
//         $('#playAudio').remove() //just to make sure that it will not have 2x audio in the background 
//     }
// }

$('button.action').click(function () {
	$('.audio_player').html('');
});

if ($('.snowflakes').length) {
	$(document).ready(function () {
		(function () {
			var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame ||
				function (callback) {
					window.setTimeout(callback, 1000 / 60);
				};
			window.requestAnimationFrame = requestAnimationFrame;
		})();


		var flakes = [],
			canvas = document.getElementById("canvas"),
			ctx = canvas.getContext("2d"),
			flakeCount = 600,
			mX = -100,
			mY = -100;

		if ($(window).width() < 768) {
			var flakeCount = 300;
		} else {
			var flakeCount = 500;
		}

		canvas.width = window.innerWidth;
		canvas.height = window.innerHeight;

		function snow() {
			ctx.clearRect(0, 0, canvas.width, canvas.height);

			for (var i = 0; i < flakeCount; i++) {
				var flake = flakes[i],
					x = mX,
					y = mY,
					minDist = 150,
					x2 = flake.x,
					y2 = flake.y;

				var dist = Math.sqrt((x2 - x) * (x2 - x) + (y2 - y) * (y2 - y)),
					dx = x2 - x,
					dy = y2 - y;

				if (dist < minDist) {
					var force = minDist / (dist * dist),
						xcomp = (x - x2) / dist,
						ycomp = (y - y2) / dist,
						deltaV = force / 2;

					flake.velX -= deltaV * xcomp;
					flake.velY -= deltaV * ycomp;

				} else {
					flake.velX *= .98;
					if (flake.velY <= flake.speed) {
						flake.velY = flake.speed
					}
					flake.velX += Math.cos(flake.step += .05) * flake.stepSize;
				}

				ctx.fillStyle = "rgba(255,255,255," + flake.opacity + ")";
				flake.y += flake.velY;
				flake.x += flake.velX;

				if (flake.y >= canvas.height || flake.y <= 0) {
					reset(flake);
				}


				if (flake.x >= canvas.width || flake.x <= 0) {
					reset(flake);
				}

				ctx.beginPath();
				ctx.arc(flake.x, flake.y, flake.size, 0, Math.PI * 2);
				ctx.fill();
			}
			requestAnimationFrame(snow);
		};

		function reset(flake) {
			flake.x = Math.floor(Math.random() * canvas.width);
			flake.y = 0;
			flake.size = (Math.random() * 3) + 2;
			flake.speed = (Math.random() * 1) + 0.5;
			flake.velY = flake.speed;
			flake.velX = 0;
			flake.opacity = (Math.random() * 0.5) + 0.3;
		}

		function init() {
			if ($(window).width() < 768) {
				var flakeCount = 300;
			} else {
				var flakeCount = 500;
			}
			// console.log("flakeCount", flakeCount)
			for (var i = 0; i < flakeCount; i++) {
				var x = Math.floor(Math.random() * canvas.width),
					y = Math.floor(Math.random() * canvas.height),
					size = (Math.random() * 3) + 2,
					speed = (Math.random() * 1) + 0.5,
					opacity = (Math.random() * 0.5) + 0.3;

				flakes.push({
					speed: speed,
					velY: speed,
					velX: 0,
					x: x,
					y: y,
					size: size,
					stepSize: (Math.random()) / 30,
					step: 0,
					opacity: opacity
				});
			}
			snow();
		};

		canvas.addEventListener("mousemove", function (e) {
			mX = e.clientX,
				mY = e.clientY
		});

		window.addEventListener("resize", function () {
			canvas.width = window.innerWidth;
			canvas.height = window.innerHeight;
		})

		init();
	});


}
